import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import { authRedirect } from "./middleware/authMiddleware";
import authReducer from "./reducers/authSlice";
import interfaceReducer from "./reducers/interfaceSlice";
import schedulesReducer from "./reducers/schedulesSlice";
import selectedServicesReducer from "./reducers/selectedServicesSlice";
import { api } from "./query/endpoints";

export const store = configureStore({
  reducer: {
    interface: interfaceReducer,
    auth: authReducer,
    schedule: schedulesReducer,
    selectedServices: selectedServicesReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware).concat(authRedirect),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
